import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import { TreeselectOptionInfo } from '@/views/Automation/CampaignCreatorV2/types';

interface Props {
  node: { raw: TreeselectOptionInfo };
  labelClassName?: string;
  checked?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TreeselectInfoOption.ts',
  props: {
    node: null,
    labelClassName: { default: '' },
    checked: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,CcIcon }
}

})